module.exports = __webpack_public_path__ + "img/wallpaper1.49a67734.jpg";